export default {"src":"/trader-new/_next/static/media/Language.9ca6eaad.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};